import { Component } from '@angular/core';
import { faCoffee, faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faFacebookF,
  faTwitter,
  faInstagram,
  faTiktok,
  faYoutube,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  faFacebook = faFacebookF;
  faTwitter = faTwitter;
  faInstagram = faInstagram;
  faCheckSquare = faCheckSquare;
  faTiktok = faTiktok;
  faYoutube = faYoutube;
  faWhatsapp = faWhatsapp;
  getWhatsAppLink(): string {
    const phone = '000000000';
    const text = encodeURIComponent('¡Hola! ¿Cómo se encuentran? Quisiera realizar una consulta en torno a la plataforma.');
    return `https://wa.me/${phone}?text=${text}`;
  }
}

